import { useStore } from 'store';
import getInputsFormData from './getInputsFormData';

export default function useInputsFormData() {
  return useStore(getInputsFormData);
}
